import React from "react";
import {
  TextField,
  Typography,
  Paper,
  Box,
  Grid2,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  SelectChangeEvent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { CompanyIdIssuanceSearchForm, Status } from "IF/interfaceType";

interface CompanyInfoSearchProps {
  searchForm: CompanyIdIssuanceSearchForm;
  handleChange: (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => void;
  handleSearch: () => void;
  handleReset: () => void;
}

const CompanyIdIssuanceSearch: React.FC<CompanyInfoSearchProps> = ({
  searchForm,
  handleChange,
  handleSearch,
  handleReset,
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Box sx={{ marginBottom: 2 }}>
        <Paper
          sx={{
            padding: "10px 10px",
            backgroundColor: theme.palette.custom.sForm,
            border: `3px solid ${theme.palette.custom.paperBorderColor}`,
          }}
        >
          <Box sx={{ width: "100%", marginBottom: 1, marginTop: 0 }}>
            <Typography fontWeight="fontWeightBold">契約企業検索</Typography>
          </Box>
          <Grid2 container spacing={1} alignItems="center">
            {/* 企業コード検索 */}
            <Grid2 size={{ xs: 12, sm: 2.5, md: 3 }}>
              <TextField
                label="企業コード"
                variant="outlined"
                fullWidth
                size="small"
                name="companyCode"
                value={searchForm.companyCode}
                onChange={handleChange}
              />
            </Grid2>

            {/* 企業名検索 */}
            <Grid2 size={{ xs: 12, sm: 3, md: 3 }}>
              <TextField
                label="企業名"
                variant="outlined"
                fullWidth
                size="small"
                name="companyName"
                value={searchForm.companyName}
                onChange={handleChange}
              />
            </Grid2>

            {/* ステータス検索 */}
            <Grid2 size={{ xs: 12, sm: 2.5, md: 3 }}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="status-label">ステータス</InputLabel>
                <Select
                  labelId="status-label"
                  label="ステータス"
                  name="status"
                  value={searchForm.status}
                  onChange={handleChange}
                >
                  <MenuItem value="">
                    <em>　</em>
                  </MenuItem>
                  <MenuItem value={Status.Inactive}>利用なし</MenuItem>
                  <MenuItem value={Status.Active}>利用中</MenuItem>
                  <MenuItem value={Status.Stop}>停止中</MenuItem>
                </Select>
              </FormControl>
            </Grid2>
            {isXs && <Grid2 size={{ xs: 4 }}></Grid2>}
            {/* 検索ボタン */}
            <Grid2 size={{ xs: 4, sm: 2, md: 1.5 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSearch}
                fullWidth
              >
                検索
              </Button>
            </Grid2>

            {/* クリアボタン */}
            <Grid2 size={{ xs: 4, sm: 2, md: 1.5 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleReset}
                fullWidth
              >
                クリア
              </Button>
            </Grid2>
          </Grid2>
        </Paper>
      </Box>
    </>
  );
};

export default CompanyIdIssuanceSearch;
